import script from "./TicketView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketView.vue?vue&type=script&setup=true&lang=js"

import "./TicketView.vue?vue&type=style&index=0&id=ee820a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee820a00"]])

export default __exports__